export enum Role {
  Viewer = 'Viewer',
  Editor = 'Editor',
  Admin = 'Admin',
}
